export default "__VITE_ASSET__8lA08qF$__"